import script from "./ResultList.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultList.vue?vue&type=script&setup=true&lang=js"

import "./ResultList.vue?vue&type=style&index=0&id=8f3d3c90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f3d3c90"]])

export default __exports__